import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const Chat = styled(Flex).attrs({
  column: true,
})`
  width: 75%;
  height: 100%;
`;

export const Header = styled(Flex).attrs({
  flex: '0 0 68px',
  width: '100%',
  align: 'center',
  justify: 'space-between',
})`
  padding: 0 15px;
  border-bottom: 2px solid rgba(40,45,48,0.1);
  background: #fff;

  a {
    line-height: 60px;
  }
`;

export const Body = styled(Flex).attrs({
  column: true,
})`
  width: 100%;
  flex: 1 1 auto;
  overflow: hidden;
`;
